import type { Translate } from '@/i18n'

/**
 * Whether a company (balance group) of this kind keeps procurement batches of
 * its own: a batch is an importer's (AFF's, ChF's) purchase, so only an
 * importer has the reports' «Партия» filter and «Свод партий» (client
 * 2026-10-27, ALFI TEST #460 and #489: «IML да хам Свод партий йук»). The
 * backend holds the same rule (model.BalanceGroupKeepsBatches).
 */
export function keepsBatches(kind: string | null | undefined): boolean {
  return kind === 'importer'
}

/** The batch number the backend gives stock without a batch (legacy «Default»); it stays so in the data. */
export const DEFAULT_BATCH_NUMBER = 'Default'

/** The batch number of stock received without a truck and without a purchase (owner 2026-11-03), as in the data. */
export const EMPTY_BATCH_NUMBER = 'Пустой'

/**
 * A batch number as shown: the «Default» batch in the viewer's language (ru
 * «Базовая», uz «Bazaviy», en «Default»; client 2026-10-25) and «Пустой» (ru
 * «Пустой», uz «Bo'sh», en «Empty»), any other as it came.
 */
export function batchLabel(t: Translate, batchNumber: string | null | undefined): string {
  const value = batchNumber ?? ''
  if (value === EMPTY_BATCH_NUMBER) return t('batchSummary.emptyRow')
  return value === DEFAULT_BATCH_NUMBER ? t('batchSummary.defaultRow') : value
}

/** A list of batch numbers joined by ", " (a sale moved to several batches), each shown with batchLabel. */
export function batchListLabel(t: Translate, batchNumbers: string): string {
  return batchNumbers
    .split(', ')
    .map((number) => batchLabel(t, number))
    .join(', ')
}
